import type { DeploymentActionResource } from "@octopusdeploy/octopus-server-client";
import { getProcessTemplateSlugFromAction, getProcessTemplateVersionMaskFromAction } from "~/areas/projects/components/Process/ProcessTemplates/processTemplateId";
import { client, repository } from "~/clientInstance";
export default function getActionLogoUrl(action: DeploymentActionResource | null) {
    if (!action || !action.Properties) {
        return "";
    }
    if (action.ActionType === "Octopus.ProcessTemplate") {
        const slug = getProcessTemplateSlugFromAction(action);
        const versionMask = getProcessTemplateVersionMaskFromAction(action);
        if (slug && versionMask && repository.spaceId) {
            return client.resolve(`/api/spaces/${repository.spaceId}/processtemplates/${slug}/${versionMask}/icon`);
        }
    }
    if (action.CommunityActionTemplateSnapshot) {
        return client.resolve(`/api/communityactiontemplates/${action.CommunityActionTemplateSnapshot.Id}/logo`);
    }
    const stepPackageVersion = action.StepPackageVersion;
    if (stepPackageVersion !== undefined) {
        const majorVersion = stepPackageVersion.split(".")[0];
        return client.resolveLinkTemplate("ActionTemplateVersionedLogo", { typeOrId: action.ActionType, version: majorVersion });
    }
    const templateId = action.Properties["Octopus.Action.Template.Id"];
    const version = action.Properties["Octopus.Action.Template.Version"];
    return templateId ? client.resolveLinkTemplate("ActionTemplateVersionedLogo", { typeOrId: templateId, version }) : client.resolveLinkTemplate("ActionTemplateLogo", { typeOrId: action.ActionType });
}
